"use client";

import { PilotProgramPage } from "@/components/shared/pilot-program-page";

const requirements = [
  {
    title: "Engaged Faculty",
    description: "1-3 courses or classes open to exploring and piloting new AI technologies."
  },
  {
    title: "Executive Support",
    description: "Involve a senior sponsor (e.g., Principal, Director of Learning and Teaching, Head of Faculty) to help define the pilot evaluation."
  },
  {
    title: "Clear Objectives",
    description: "Designed for colleges that want to enrich their teaching and learning in both in-class and online settings."
  },
  {
    title: "Feedback Loop",
    description: "Commitment to gathering and sharing student/faculty feedback throughout the pilot to include in the evaluation report."
  },
  {
    title: "Pilot Evaluation",
    description: "Our 6-12 month pilot provides time to evaluate impact and make informed decisions about wider implementation."
  },
  {
    title: "Pilot Budget",
    description: "A modest pilot fee covers our programme support, all integrations, and pilot evaluation study."
  }
];

export default function PilotProgramFEColleges() {
  return (
    <PilotProgramPage
      variant="cwm"
      title={<>Join Our 2026-2027<br />Colleges Pilot Programme</>}
      subtitle="Ready to close your teaching and learning loop? StudyStash delivers secure, AI-powered learning within institutional guardrails."
      caseStudyLink="/about/case-studies/jcc"
      caseStudyImage="/jcc_studystash.png"
      caseStudyAlt="Joseph Chamberlain College StudyStash Case Study"
      reportImage="/jcc_studystash_right.png"
      reportAlt="Joseph Chamberlain College StudyStash Report"
      whyPilotTitle="Hear Why Colleges Pilot"
      institutionType="college"
      requirements={requirements}
    />
  );
}

